var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WxPhoneX',[_c('div',{directives:[{name:"stat",rawName:"v-stat.click",value:({
      tag: 'comp-rule.rule|條款與細則點擊',
      ext: { fbusiness: _vm.fbusiness }
    }),expression:"{\n      tag: 'comp-rule.rule|條款與細則點擊',\n      ext: { fbusiness }\n    }",modifiers:{"click":true}}],staticClass:"tnc",style:({ color: _vm.color }),on:{"click":_vm.toTnc}},[(_vm.$slots.icon)?_vm._t("icon"):_vm._e(),_c('FitIcon',{staticClass:"icon",attrs:{"namespace":"wphk-ui","icon":"tnc"}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title || _vm.i18n('條款與細則')))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }